export type LastPaymentTransactionType = "sales" | "expenses" | "purchases";

export function getLastPaymentMethodKey(
  transactionType: LastPaymentTransactionType,
  companyId?: string | number | null,
) {
  const company = String(companyId ?? "").trim();
  if (!company) return null;
  return `nimos:lastPaymentMethod:${transactionType}:${company}`;
}

export function readLastPaymentMethod(
  transactionType: LastPaymentTransactionType,
  companyId?: string | number | null,
) {
  const key = getLastPaymentMethodKey(transactionType, companyId);
  if (!key) return null;

  try {
    const value = window.localStorage.getItem(key);
    return value && value.trim() ? value : null;
  } catch {
    return null;
  }
}

export function writeLastPaymentMethod(
  transactionType: LastPaymentTransactionType,
  companyId: string | number | null | undefined,
  paymentMethodId: string | number | null | undefined,
) {
  const key = getLastPaymentMethodKey(transactionType, companyId);
  const value = String(paymentMethodId ?? "").trim();
  if (!key || !value) return;

  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Best-effort preference only.
  }
}
